import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

// Same icon-link pattern as Footer/Contact, on the light surface.
export const ContactLink = styled.a`
  display: flex;
  align-items: center;
  gap: ${themeGet('space.5')}px;
  text-decoration: none;

  > span {
    color: ${themeGet('colors.text.body')};

    &:hover {
      color: ${themeGet('colors.text.muted')};
    }
  }

  > svg {
    flex-shrink: 0;
    color: ${themeGet('colors.text.muted')};
    width: 16px;
    height: 16px;
  }
`
